<template>
  <div class="grid gap-6 pb-10 border-b">
    <AtomInfoBox :description="$t('restaurant.closed.info', restaurant)" />
    <div class="grid gap-4">
      <RestaurantBlockHeader 
        :label="$t('restaurant.closed.related.label')"
        :heading="$t('restaurant.closed.related.heading', restaurant)"
      />
      <div class="grid gap-3 md:gap-6 grid-cols-12" v-auto-animate>
        <div v-for="restaurant, key in restaurants?.slice(0, 12)" :key="restaurant.id" class="col-span-full sm:col-span-6 xl:col-span-4">
          <NuxtLink :to="{ name: 'restaurants-slug', params: { slug: restaurant.slug }}">
            <RestaurantsCard :position="key+1" :restaurant="restaurant" />
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})

// Fetch related restaurants
const { data } = await useFetch(`/restaurants`, { 
  key: `related-restaurants-${props.restaurant.slug}`,
  baseURL: useEnv('apiBase'),
  query: {
    bookable: true,
    latitude: props.restaurant.location?.lat, 
    longitude: props.restaurant.location?.lon,
    distance: 10000, 
    sortBy: 'distance',
  }
})

// Grep restaurants from data
const restaurants = computed(() => data.value?.data) 
</script>